import ClientAssetModule from "../assets/ClientAssetModule";
import type { ClientAssetModuleProps } from "../assets/ClientAssetModule";
import theme from "./LifeBoat.module.css";

type Props = Omit<ClientAssetModuleProps, "type" | "themeClassName">;

export default function LifeBoatPage(props: Props) {
  return (
    <ClientAssetModule
      {...props}
      type="Life Boat"
      themeClassName={theme.theme}
    />
  );
}
